import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "./auth/auth-context";
import { App } from "./app";
import { AppErrorPage } from "./components/app-error-page";
import "./app/fonts";
import "./app/globals.css";
import "./app/themes.css";
import { initializeDesign } from "./lib/design";
import { initializeColorTheme } from "./lib/color-theme";
import { applyDocumentLanguage } from "./lib/language";
import { installModuleRecovery } from "./lib/module-recovery";

const removeModuleRecovery = installModuleRecovery();
if (import.meta.hot) import.meta.hot.dispose(removeModuleRecovery);

initializeDesign();
initializeColorTheme();
// Set before the first render so `<html lang>` never shows the static default for a saved language.
applyDocumentLanguage();

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element is missing");
}

const router = createBrowserRouter([{ path: "*", element: <AuthProvider><App /></AuthProvider>, errorElement: <AppErrorPage /> }]);

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
